<template>
  <section class="areatotle">
    <van-grid>
      <van-grid-item text="正常企业" @click="OnDetailClick(1)">
        <div class="zcqy">
          <div class="spantitle">正常企业</div>
          <img src="../../modules/assets/zcbiao.jpg" />
          <span>{{MonitorTotal.zc}}</span>
        </div>
      </van-grid-item>
    </van-grid>
    <van-grid>
      <van-grid-item text="离线企业" @click="OnDetailClick(3)">
        <div class="zcqy">
          <div class="spantitle">离线企业</div>
          <img src="../../modules/assets/tubiao.jpg" />
          <span>{{MonitorTotal.lx}}</span>
        </div>
      </van-grid-item>
    </van-grid>
    <van-grid>
      <van-grid-item text="超标企业" @click="OnDetailClick(5)">
        <div class="zcqy">
          <div class="spantitle">超标企业</div>
          <img src="../../modules/assets/tubiao_1.jpg" />
          <span>{{MonitorTotal.cb}}</span>
        </div>
      </van-grid-item>
    </van-grid>
    <van-grid>
      <van-grid-item text="报修企业" @click="OnDetailClick(2)">
        <div class="zcqy">
          <div class="spantitle">报修企业</div>
          <img src="../../modules/assets/tubiao_2.jpg" />
          <span>{{MonitorTotal.bx}}</span>
        </div>
      </van-grid-item>
    </van-grid>
  </section>
</template>
<script>
import { BzAjax, BzJs, BzUser, BzMsg } from "@/modules/js/helper";
export default {
  data() {
    return {
      AreaID: 0,
      MonitorTotal: {}
    };
  },
  created() {
    this.AreaID = this.$route.params.AreaID;
    this.getlist();
  },
  methods: {
    OnDetailClick(status) {
      this.$router.push("/monitorlist/" +  this.AreaID +"/0/"+status);
    },
    getlist: function() {
      BzAjax.post("/WSD/Monitor/MonitorTotal", { AreaID: this.AreaID }).then(d => {
        this.MonitorTotal = d;
      });
      //   BzAjax.get("app/Monitor/MonitorTotal", { AreaID: this.AreaID }).then(d => {
      //     this.list = d.Areas;
      //     if (d.StoreID != 0) {
      //     } else {
      //     }
      //   });
    }
  }
};
</script>
<style lang="less">
.areatotle {
  margin-top: 5rem;
  .van-grid {
    width: 100%;
  }
  .zcqy {
    height: 2.5rem;
    width: 100%;
    display: flex;
    .spantitle {
      width: 5rem;
      text-align: right;
      line-height: 2.5rem;
    }
    img {
      margin-left: 2.4rem;
    }
    span {
      margin-left: 1.2rem;
      font-size: 2.4rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/AreaTotle.vue